require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_COMPONENT = exports.ADD_COMPONENT = 'ADD_COMPONENT';
var REMOVE_COMPONENT = exports.REMOVE_COMPONENT = 'REMOVE_COMPONENT';
var WATCH_COMPONENT = exports.WATCH_COMPONENT = 'WATCH_COMPONENT';
var SET_QUERY = exports.SET_QUERY = 'SET_QUERY';
var SET_QUERY_OPTIONS = exports.SET_QUERY_OPTIONS = 'SET_QUERY_OPTIONS';
var EXECUTE_QUERY = exports.EXECUTE_QUERY = 'EXECUTE_QUERY';
var UPDATE_HITS = exports.UPDATE_HITS = 'UPDATE_HITS';
var UPDATE_AGGS = exports.UPDATE_AGGS = 'UPDATE_AGGS';
var UPDATE_COMPOSITE_AGGS = exports.UPDATE_COMPOSITE_AGGS = 'UPDATE_COMPOSITE_AGGS';
var ADD_CONFIG = exports.ADD_CONFIG = 'ADD_CONFIG';
var ADD_APPBASE_REF = exports.ADD_APPBASE_REF = 'ADD_APPBASE_REF';
var LOG_QUERY = exports.LOG_QUERY = 'LOG_QUERY';
var LOG_COMBINED_QUERY = exports.LOG_COMBINED_QUERY = 'LOG_COMBINED_QUERY';
var SET_VALUE = exports.SET_VALUE = 'SET_VALUE';
var SET_INTERNAL_VALUE = exports.SET_INTERNAL_VALUE = 'SET_INTERNAL_VALUE';
var PATCH_VALUE = exports.PATCH_VALUE = 'PATCH_VALUE';
var CLEAR_VALUES = exports.CLEAR_VALUES = 'CLEAR_VALUES';
var SET_LOADING = exports.SET_LOADING = 'SET_LOADING';
var SET_ERROR = exports.SET_ERROR = 'SET_ERROR';
var SET_STREAMING = exports.SET_STREAMING = 'SET_STREAMING';
var PUSH_TO_STREAM_HITS = exports.PUSH_TO_STREAM_HITS = 'PUSH_TO_STREAM_HITS';
var SET_TIMESTAMP = exports.SET_TIMESTAMP = 'SET_TIMESTAMP';
var SET_HEADERS = exports.SET_HEADERS = 'SET_HEADERS';
var SET_MAP_DATA = exports.SET_MAP_DATA = 'SET_MAP_DATA';
var SET_QUERY_LISTENER = exports.SET_QUERY_LISTENER = 'SET_QUERY_LISTENER';
var STORE_KEY = exports.STORE_KEY = '__REACTIVESEARCH__';
var SET_SEARCH_ID = exports.SET_SEARCH_ID = 'SET_SEARCH_ID';
var SET_PROMOTED_RESULTS = exports.SET_PROMOTED_RESULTS = 'SET_PROMOTED_RESULTS';
var SET_DEFAULT_QUERY = exports.SET_DEFAULT_QUERY = 'SET_DEFAULT_QUERY';
var SET_CUSTOM_QUERY = exports.SET_CUSTOM_QUERY = 'SET_CUSTOM_QUERY';
var SET_CUSTOM_HIGHLIGHT_OPTIONS = exports.SET_CUSTOM_HIGHLIGHT_OPTIONS = 'SET_CUSTOM_HIGHLIGHT_OPTIONS';
var SET_CUSTOM_DATA = exports.SET_CUSTOM_DATA = 'SET_CUSTOM_DATA';
var SET_APPLIED_SETTINGS = exports.SET_APPLIED_SETTINGS = 'SET_APPLIED_SETTINGS';
var SET_PROPS = exports.SET_PROPS = 'SET_PROPS';
var UPDATE_PROPS = exports.UPDATE_PROPS = 'UPDATE_PROPS';
var REMOVE_PROPS = exports.REMOVE_PROPS = 'REMOVE_PROPS';
var SET_MAP_ON_TOP_MARKER = exports.SET_MAP_ON_TOP_MARKER = 'SET_MAP_ON_TOP_MARKER';
var SET_MAP_OPEN_MARKERS = exports.SET_MAP_OPEN_MARKERS = 'SET_MAP_OPEN_MARKERS';
var SET_SUGGESTIONS_SEARCH_VALUE = exports.SET_SUGGESTIONS_SEARCH_VALUE = 'SET_SUGGESTIONS_SEARCH_VALUE';
var CLEAR_SUGGESTIONS_SEARCH_VALUE = exports.CLEAR_SUGGESTIONS_SEARCH_VALUE = 'CLEAR_SUGGESTIONS_SEARCH_VALUE';
var SET_SUGGESTIONS_SEARCH_ID = exports.SET_SUGGESTIONS_SEARCH_ID = 'SET_SUGGESTIONS_SEARCH_ID';
var UPDATE_ANALYTICS_CONFIG = exports.UPDATE_ANALYTICS_CONFIG = 'UPDATE_ANALYTICS_CONFIG';
var SET_RAW_DATA = exports.SET_RAW_DATA = 'SET_RAW_DATA';